import { Button, ConfigProvider } from 'antd';
import './index.css';

/**
 * Красная кнопка на основе Ant Design Button.
 * 
 * @param {{ primaryColor?: string } & import('antd/es/button/button.d.ts').ButtonProps} props - Пропсы компонента.
 * @param {string} [props.primaryColor] - Цвет кнопки (по умолчанию #FF4D4F).
 * @returns {JSX.Element}
 * 
 * Все остальные пропсы наследуются от Ant Design Button:
 * https://ant.design/components/button/#API
 */
export const RedButton = ({ primaryColor, ...props }) => (
    <ConfigProvider theme={{ token: { colorPrimary:'#FF4D4F' } }}>
        <Button {...props} className="ant-outline-to-solid-button" />
    </ConfigProvider>
)